module.exports = __webpack_public_path__ + "static/Jenkins_Balloon-143a0ca67a31bd88d4b6fb1aaf86c75d.png";